import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Renderer2 } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class ScriptService {
    constructor(
        @Inject(DOCUMENT) private _document: Document
    ) { }

    /**
     * Registers the script in the component
     * @param renderer2 The Angular Renderer
     * @param url The url of javascript to be added
     */
    public registerScript(renderer2: Renderer2, url: string): void {
        if (!url) return;

        const script = renderer2.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        renderer2.appendChild(this._document.body, script);
    }
}